import * as types from "../actions/actionTypes";
import createEntityReducer from "./createEntityReducer";

export default createEntityReducer({
  entity: "ordertimelineevent",
  listKey: "events",
  itemKey: "event",
  getAll: types.GET_ALL_ORDER_TIMELINE_EVENTS,
  getAllResponse: types.GET_ALL_ORDER_TIMELINE_EVENTS_RESPONSE,
  getByIdResponse: types.GET_ORDER_TIMELINE_EVENT_BY_ID_RESPONSE,
});
